import SurveyStatusMapping from "./SurveyStatusMapping";

export default SurveyStatusMapping;
